import * as pConst from "../consts/profiles-consts.js";
import * as wConst from "../consts/website-consts.js";
import {isNullOrUndefined} from "../actions/website-actions";
export const InitState = {
  Loaded: false,
  SSRAds: {},
};

export const adReducer = (state = InitState, action) => {
  switch (action.type) {
    case wConst.FETCH_SSRADS_PENDING: {
      let tObj = {Loaded: false, ApiResult: {Code: 500, Message: "Loading"}};
      state.SSRAds[action.payload] = tObj;
      break;
    }
    case wConst.FETCH_SSRADS_REJECTED: {
      let tObj = {Loaded: true, ApiResult: action.payload.Value};
      state.SSRAds[action.payload.Key] = tObj;
      break;
    }
    case wConst.FETCH_SSRADS_FULLFILLED: {
      let tObj = {Loaded: true, ApiResult: action.payload.Value};
      state.SSRAds[action.payload.Key] = tObj;
      break;
    }
  }
  return state;
};


